import IKennelCardQuestion from '../interfaces/IKennelCardQuestion'

export const parserQuestionForm = (questions: any): IKennelCardQuestion[] => {
  let result: IKennelCardQuestion[] = []
  
  if (questions) {
    questions.forEach(question => {
      let obj = {} as IKennelCardQuestion
      
      if (typeof question.value === 'string') {
        obj.title = question.value
      }
      if (typeof question.answers === 'object') {
        obj.options = question.answers.filter(answer => typeof answer === 'object' && answer.value).map(answer => answer.value)
      }

      if (obj.title && obj.options) {
        result.push(obj)
      }
    })
  }

  return result
}
